module.exports = __webpack_public_path__ + "img/generalActive.a6520287.png";